import PaginatedListState from 'flarum/common/states/PaginatedListState';
export default class IssueListState extends PaginatedListState {
  get type() {
    return 'github-issues';
  }
  constructor(params) {
    if (params === void 0) {
      params = {};
    }
    super(params);
  }
  getAllItems() {
    return super.getAllItems();
  }
}
flarum.reg.add('sycho-github-milestone', 'forum/states/IssueListState', IssueListState);